import React from 'react';
import LoadingCircle from '../Global/LoadingCircle';
import pencilIcon from "../../assets/icons/pencil.svg";
import xIcon from "../../assets/icons/x.svg";

const AttendanceMatrix = ({
  matrixData,
  loadingMatrix,
  searchTerm,
  setSearchTerm,
  canManage,
  isEditMode,
  setIsEditMode,
  setRenameTarget,
  setNewTitle,
  handleAddPresence,
  handleDeletePresence,
  t
}) => {
  if (loadingMatrix) {
    return (
      <div className="matrixLoading">
        <LoadingCircle />
        <p>{t.loadingMatrix}</p>
      </div>
    );
  }

  if (!matrixData) {
    return (
      <div className="noAttendancesText">
        <p>{t.noAttendances}</p>
      </div>
    );
  }

  return (
    <div className="attendanceSpreadsheetWrapper">
      <div className="matrixToolbar">
        <div className="matrixToolbarLeft">
          <input
            type="text"
            className="matrixSearchInput"
            placeholder={t.searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {canManage && (
            <button
              className={`matrixEditBtn ${isEditMode ? 'active' : ''}`}
              onClick={() => setIsEditMode(!isEditMode)}
              title={isEditMode ? "Opriți Editarea" : "Editează"}
            >
              <img
                src={isEditMode ? xIcon : pencilIcon}
                alt={isEditMode ? "Close" : "Edit"}
                className="editBtnIcon"
              />
            </button>
          )}
        </div>
      </div>
      <div className="matrixScrollContainer">
        <table className="attendanceMatrix">
          <thead>
            <tr>
              <th className="sticky-col first-col">{t.userHeader}</th>
              <th className="sticky-col total-col" style={{ left: '220px' }}>{t.totalPresent}</th>
              <th className="sticky-col action-col" style={{ left: '310px' }}>{t.actionHeader || "Acțiune"}</th>
              {matrixData.sessions.map((session) => (
                <th
                  key={session.id}
                  title={session.title}
                  onClick={() => {
                    if (canManage && isEditMode) {
                      setRenameTarget(session.id);
                      setNewTitle(session.title);
                    }
                  }}
                  className={canManage && isEditMode ? "rename-clickable" : ""}
                >
                  <div className="sessionHeaderCell">
                    <span className="sessionDate">
                      {new Date(session.created_at).toLocaleDateString("ro-RO", {
                        day: "2-digit",
                        month: "2-digit",
                      })}
                    </span>
                    <span className="sessionTitle">{session.title}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {matrixData.users
              .filter((u) =>
                u.name.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map((userData) => {
                return (
                  <tr key={userData.id}>
                    <td className="sticky-col first-col">
                      <div className="matrixUserInfo">
                        <span className="matrixUserName">{userData.name}</span>
                        <span className="matrixUserEmail">{userData.email}</span>
                      </div>
                    </td>
                    <td className="sticky-col total-col" style={{ left: '220px' }}>
                      <span className="totalBadge">{userData.attendancePercentage}%</span>
                    </td>
                    <td className="sticky-col action-col" style={{ left: '310px' }}>
                      {userData.action && (
                        <span className={`statusIndicator actionBadge ${userData.action}`}>
                          {userData.action}
                        </span>
                      )}
                    </td>
                    {matrixData.sessions.map((session) => {
                      const status = userData.presences[session.id];
                      return (
                        <td
                          key={session.id}
                          className={`status-cell ${isEditMode ? 'edit-active' : ''}`}
                        >
                          <div className={`statusIndicator ${status}`}>
                            {status === "VALIDATED" ? "✓" :
                              status === "PENDING" ? "⏳" :
                                status === "REJECTED" ? "✕" : ""}
                          </div>
                          {canManage && isEditMode && (
                            <div
                              className={`presenceOverlay ${status === 'ABSENT' ? 'add' : 'delete'}`}
                              onClick={() => status === 'ABSENT' ? handleAddPresence(session.id, userData.id) : handleDeletePresence(session.id, userData.id)}
                              title={status === 'ABSENT' ? "Adaugă prezență" : "Șterge prezența"}
                            >
                              {status === 'ABSENT' ? '+' : '✕'}
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceMatrix;
